<script setup lang="ts">
import type { NetworkDataFromListing } from '~/interfaces/network'

const props = defineProps({
    network: {
        type: Object as PropType<NetworkDataFromListing>,
        required: true
    },
    rating: {
        type: Number,
        default: 0
    }
})

const config = useRuntimeConfig()
const defaultImage = ref(`${config.app.cdnURL}/images/defaultNetwork.png`)

const networkImage = ref(
    `${config.public.S3_ASSETS_URL}/networks/${props.network.slug}.png`
)
</script>

<template>
    <a
        class="ranked-network"
        :href="`/networks/${props.network.slug}`"
        :title="network.name"
    >
        <div class="h-3/4 md:h-1/2 flex flex-col justify-center items-center">
            <NuxtImg
                class="max-h-[65px] md:max-h-[75%] md:max-w-[75%]"
                :src="networkImage"
                :alt="network.name"
                :placeholder="defaultImage"
            />
        </div>
        <div v-if="rating" class="flex justify-center items-center gap-2">
            <IconStarFull class="h-5 text-sky-500" />
            <span
                class="text-center text-neutral-900 text-xl md:text-3xl font-bold font-inter"
            >
                {{ rating.toFixed(2) }}
            </span>
        </div>
    </a>
</template>

<style lang="scss" scoped>
.ranked-network {
    @apply h-28 w-40 md:w-48 lg:w-56 md:h-40 lg:h-56 p-2 bg-white rounded-lg border border-zinc-300 lg:border-none flex flex-col justify-center items-center gap-2 hover:bg-slate-100;
}
</style>
